/**
 * Created by andrey on 23.10.2020.
 */

const AdminLevelDragShadow = cc.Scale9Sprite.extend({
    ctor: function (adminLevel) {
        this.adminLevel = adminLevel;

        const frame = bundles.admin.frames.selected_button.resolve();
        const size = frame.getRect();
        this._super(frame, cc.rect(size.width / 2 - 1, size.height / 2 - 1, 2, 2));
        this.setContentSize2(cleverapps.styles.AdminLevelsView.cellSize);
        this.setLocalZOrder(-2);

        this.createText();

        adminLevel.on("updateEpisode", this.onUpdateEpisode.bind(this), this);
    },

    createText: function () {
        if (this.text) {
            this.text.removeFromParent();
        }

        const original = this.adminLevel.originalEpisodeNo;
        const episodeNo = this.adminLevel.episodeNo;

        let msg = "";
        if (original !== episodeNo) {
            msg = `To episode:\n${episodeNo}`;
        }

        const text = this.text = cleverapps.UI.generateOnlyText(msg, cleverapps.styles.FONTS.ADMIN_LEVEL_TEXT);
        text.setAlignment(this.width / 2, this.height / 2);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        this.addChild(text);
    },

    onUpdateEpisode: function () {
        this.createText();
    }
});